import MarketingHeader from "@/components/layout/MarketingHeader";
import MarketingFooter from "@/components/layout/MarketingFooter";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const FAQS = [
  {
    q: "How is this different from a budgeting app?",
    a: "Budgeting apps ask you to sort spending into categories. What&rsquo;s Your Balance? answers a different question: will your next paycheck cover what&rsquo;s due? We focus on timing, not tagging.",
  },
  {
    q: "How does the 1-month free trial work?",
    a: "You sign up with just an email and password. Your account is fully active for 30 days. You’ll only be charged if you subscribe from the Subscription page before your trial ends.",
  },
  {
    q: "Do you support weekly, biweekly, and monthly paychecks?",
    a: "Yes. The pay period planner groups bills under whichever paycheck covers them — including 3-paycheck months and pay periods that cross month boundaries.",
  },
  {
    q: "What happens to unpaid bills at month end?",
    a: "Any unpaid bill from a previous month appears in a dedicated &ldquo;Prior Month Bills&rdquo; container at the top of your Bills page so nothing quietly disappears. You can mark it paid, reschedule it, or delete it from right there.",
  },
  {
    q: "What are Safe, Tight, and Warning?",
    a: "Automatic status labels shown on your Cash-flow forecast. Safe = you cover every unpaid bill with a comfortable cushion. Tight = you cover them with only a small cushion, so any surprise could tip you negative. Warning = your available money plus expected income doesn&rsquo;t cover every bill in the window. Tap any label to open a plain-English explanation with next steps.",
  },
  {
    q: "Can I try it without entering my real data?",
    a: "Yes — during onboarding, pick “Explore sample demo data”. We’ll load a realistic dataset you can play with.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Absolutely. Head to Subscription in your account. You keep access until the end of your current billing period.",
  },
];

export default function Faq() {
  return (
    <div className="min-h-screen" data-testid="marketing-faq">
      <MarketingHeader />
      <section className="max-w-3xl mx-auto px-6 md:px-8 py-20">
        <div className="text-center mb-12">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#8A918D] mb-3">Frequently asked</div>
          <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-[#2C302E]">
            Answers, in plain English.
          </h1>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="card-soft !p-0 overflow-hidden border-[#EBE6E0]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="px-6 py-5 text-left font-heading font-medium text-[#2C302E] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 text-[#59605C] leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-14 text-center">
          <Link to="/signup" data-testid="faq-cta-signup" className="btn-primary">
            Start free trial
          </Link>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
